
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class ClickOutsideController extends Controller {

	/**
	* I get called whenever this instance is bound to a host element.
	*/
	connect() {

		window.addEventListener( "click", this.handleClick );

	}


	/**
	* I get called whenever this instance is unbound from a host element.
	*/
	disconnect() {

		window.removeEventListener( "click", this.handleClick );

	}

	// ---
	// PRIVATE METHODS.
	// ---

	/**
	* I handle all window clicks and translate them into dispatched events (as needed).
	*/
	handleClick = ( event ) => {

		if ( this.isOutsideHostElement( event.target ) ) {

			this.dispatch(
				"click",
				{
					detail: {
						originalEvent: event
					}
				}
			);

		}

	};


	/**
	* I determine if the given target is outside the host element.
	*/
	isOutsideHostElement( target ) {

		if ( this.element === target ) {

			return( false );

		}

		return( ! this.element.contains( target ) );

	}

}
